<template>
  <div class="translation_box">
    <template>
      <div class="tabs_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="1" label="翻译任务" class="a">
            <div slot="label" class="table-box">
              <span class="span-box">{{ $t('myTaskV2.translateTask') }}</span>
              <span :class="this.activeName == '1' ? 'action-badge' : 'badge'">
                <el-badge is-dot :hidden="!(taskNums.translationReadStatus)">
                  <span class="num">{{ taskNums.translationTask || 0 }}</span>
                </el-badge>
              </span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审校任务" name="2">
            <div slot="label" class="table-box">
              <span class="span-box">{{ $t('myTaskV2.checkTask') }}</span>
              <span :class="this.activeName == '2' ? 'action-badge' : 'badge'">
                <el-badge is-dot :hidden="!(taskNums.reviewReadStatus)">
                  <span class="num">{{ taskNums.reviewTheTask || 0 }}</span>
                </el-badge>
              </span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="终审任务" name="3">
            <div slot="label" class="table-box" style=" border-right: none;">
              <span class="span-box">{{ $t('myTaskV2.schoolTask') }}</span>
              <span :class="this.activeName == '3' ? 'action-badge' : 'badge'">
                <el-badge is-dot :hidden="!(taskNums.proofreadingReadStatus)">
                  <span class="num">{{ taskNums.proofreadingTasks || 0 }}</span>
                </el-badge>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="fileter">
          <el-popover placement="bottom" width="200" trigger="click" popper-class="filter-search">
            <div class="fileter-item" slot="reference" :style="$i18n.locale === 'zh' ? '' : 'width:85px;'">
              {{ $t('task.filtrate') }}
            </div>
            <ul>
              <li class="fileter-title">
                {{ $t('task.filtrate') }}
              </li>
              <li>
                <el-input :placeholder="$t('task.Pleaseenterthetaskname')" v-model="taskName" @clear="clearName" clearable
                  @input="changInput">
                </el-input>
              </li>
              <li class="fileter-status">
                {{ $t('task.state') }}
                <el-select v-model="status" :placeholder="$t('task.Pleaseselectstatus')">
                  <el-option v-for="item in options" :key="item.value"
                    :label="$i18n.locale === 'zh' ? item.label : inlabel(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </li>
              <li>
                <el-button class="clearsearch" @click="clearsearch">{{ $t('common.reset') }}
                </el-button>
                <el-button type="primary" @click="searchName" class="search">{{ $t('common.Search') }}
                </el-button>
              </li>
            </ul>
          </el-popover>
        </div>
      </div>
      <div class="line"></div>
      <div class="bottom_form">
        <!-- 列表表格分页开始 -->
        <div class="table">
          <el-table :data="list" border height="calc(100% - 60px)" @sort-change="sortChange"
            header-row-class-name="customHeader">
            <el-table-column type="index" width="52" :index="indexMethod" :label="$t('myTaskV2.serialNumber')"
              align="center">
              <template v-slot="{ $index , row }">
                <el-badge is-dot class="badge-index" :hidden="!(row.isUnread)"></el-badge>
                <span>{{ $index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column class-name="file-name" prop="fileName" align="center" :label="$t('project.taskName')"
              show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span :class="`fileName_box icon-${row.suffix.toLocaleLowerCase()}`" @click="toEditor(row)">{{
                  row.fileName }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('myTaskV2.taskType')" width="90" align="center" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ getTasktpyeName(row.taskType) }}</template>
            </el-table-column>

            <el-table-column prop="projectName" :label="$t('task.project')" align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="pmName" :label="$t('myTaskV2.projectManager')" align="center" width="120"
              show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="languageDirection" :label="$t('myTaskV2.languageDirection')" align="center"
              show-overflow-tooltip>
              <template slot-scope="{ row }">
                <template v-if="$i18n.locale === 'zh'">{{ row.langDesc.split('>')[0] }} —
                  {{ row.langDesc.split('>')[1] }}</template>
                <template v-else>{{ $langCase[row.sourceLang] }} —
                  {{ $langCase[row.targetLang] }}</template>
              </template>
            </el-table-column>

            <el-table-column prop="sourceWordNum" :label="$t('project.wordNumber')" align="center" show-overflow-tooltip
              width="90">
            </el-table-column>

            <el-table-column prop="limitTime" :label="$t('myTaskV2.deadline')" sortable="custom" align="center"
              show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span :class="{ overdue: new Date() > new Date(row.limitTime) && row.finish != 1 }">{{ row.limitTime
                }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('myTaskV2.progress')" align="center">
              <template slot-scope="{ row }">
                <el-progress :percentage="row.progress"></el-progress>
              </template>
            </el-table-column>

            <el-table-column prop="status" :label="$t('project.status')" align="center" show-overflow-tooltip width="120">
              <template slot-scope="{ row }">
                <div :class="`task-status status-${finishFormat(row)}`">
                  <span>{{ statusFormat(row) }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop :label="$t('myTaskV2.operate')" align="center" width="135">
              <template slot-scope="{ row }">
                <div class="iconList">
                  <el-tooltip class="item" effect="dark" :content="$t('myTaskV2.open')" placement="top">
                    <i class="icon-edit" style="cursor:pointer;" @click="toEditor(row)"></i>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" :content="$t('myTaskV2.exportTranslation')" placement="top">
                    <i class="icon-down" style="cursor:pointer;" @click="handleTaskDownload(row)"></i>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" :content="$t('myTaskV2.offlineFile')" placement="top"
                    v-if="([0, 2].includes(row.finish))">
                    <i class="icon-upload" style="cursor:pointer;" @click="handleTaskUpload(row)"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--列表表格分页结束-->
        <div class="pagination">
          <el-pagination background :pager-count="5" @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="page" :page-sizes="[10, 20, 30, 40]" layout="prev, pager, next, sizes"
            :page-size.sync="rows" :total="total" />
        </div>
      </div>
    </template>
    <taskUpload :visible="taskVisible" :taskInfo="taskInfo" @handleCancel="handleCancel" />
  </div>
</template>

<script>
import { getTaskPage } from "@/services/myTask.js";
// import { getTaskNum } from "@/services/myTask";
import taskUpload from "../taskUpload/index";
import { apiRoot } from "@/services/ajax.js";
import { mapActions, mapState } from 'vuex';
export default {
  name: "collateTask",
  props: {
  },
  components: { taskUpload },
  data() {
    return {
      list: [],
      page: "",
      rows: 10,
      total: 0,
      sort: null,
      taskInfo: {},
      taskVisible: false,
      status: "",
      userId: "",
      taskName: "",
      // taskNums: {},
      activeName: "1", //被激活页签
      options: [
        {
          value: "5",
          label: "全部",
        },
        {
          value: "1",
          label: "已完成",
        },
        {
          value: "0",
          label: "进行中",

        },
        {
          value: "2",
          label: "未开始",

        },
        {
          value: "3",
          label: "已逾期",

        },
        {
          value: "4",
          label: "逾期完成",
        }
      ]
    };
  },
  created() {
    // this.page = Number(sessionStorage.getItem("myCurrentPage1")) || 1;
    this.status = "5"
    this.page = 1;
    this.getTaskPage(this.page);
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id;

  },
  computed:{
    ...mapState({
      taskNums:(state) => state.taskNums
    })
  },
  mounted() {
    this.activeName = "1";
    let tabDOm = document.getElementsByClassName("el-tabs__active-bar")[0];
    this.activeName === "3" ? tabDOm.style.left = "15px" : tabDOm.style.left = "0px"
    this.getTaskNums();
  },
  methods: {
    ...mapActions(['getTaskNums']),
    inlabel(row) {
      switch (row) {
        case "全部":
          return this.$t('common.all');
          break;
        case "已完成":
          return this.$t('myTaskV2.complete');
          break;
        case "进行中":
          return this.$t('projectDetailsV2.inProgress');
          break;
        case "未开始":
          return this.$t('projectDetailsV2.notBegin');
          break;
        case "已逾期":
          return this.$t('projectDetailsV2.overdue');
          break;
        case "逾期完成":
          return this.$t('projectDetailsV2.overdueComplete');
          break;
        default:
          break;
      }
    },
    //空格处理
    changInput() {
      this.taskName = this.taskName.replace(/^\s*/g, '');
    },

    //清除搜索
    clearName() {
      this.taskName = '';
      this.getTaskPage(this.page);
    },
    clearsearch() {
      this.taskName = '';
      this.status = '';
      this.getTaskPage(this.page);
    },
    //搜索
    searchName() {
      this.page = 1;
      this.getTaskPage(this.page);
    },
    //状态筛选
    // changeSelect() {
    //   this.getTaskPage(this.page);
    // },
    handleClick(tab) {
      this.page = 1;
      this.activeName = tab._props.name;
      this.getTaskPage(this.page);
      // sessionStorage.setItem("getnumber", this.activeName); 
    },
    //获取任务数量
    // async getTaskNums() {
    //   let params = {
    //     userId: this.userId,
    //     fileId: 0
    //   };
    //   const res = await getTaskNum(params);
    //   if (res.success && res.status == 200) {
    //     this.taskNums = res.result;
    //   }
    // },
    finishFormat(row) {
      if (row.finish === 0) { //未开始
        return 0;
      } else if (row.finish === 2) { //进行中
        return 2;
      } else if (row.finish === 1) { //已完成 
        return 1;
      } else if (row.finish === 3) {//逾期
        return 3;
      } else if (row.finish === 4) {//逾期完成
        return 4;
      }
    },
    statusFormat(row) {
      if (row.finish === 0) {
        return this.$t('projectDetailsV2.notBegin');
      } else if (row.finish === 2) {
        return this.$t('projectDetailsV2.inProgress');
      } else if (row.finish === 1) {
        return this.$t('projectDetailsV2.completed');
      } else if (row.finish === 3) {
        return this.$t('projectDetailsV2.overdue');
      } else if (row.finish === 4) {
        return this.$t('projectDetailsV2.overdueComplete');
      }
    },
    indexMethod(index) {
      if (index < 9) {
        index += 1;
        return index;
      } else {
        return index + 1;
      }
    },
    // 每页显示条数切换
    handleSizeChange(newSize) {
      this.rows = newSize
      this.getTaskPage(this.page, this.sort);
    },
    //获取任务列表
    async getTaskPage(page, sort) {
      let params = {
        page,
        rows: this.rows,
        sort: sort || { create_time: "desc" },
        filter: {
          taskType: this.activeName,
          task_name: this.taskName,
          taskFinishType: this.status
        }
      };
      const res = await getTaskPage(params);
      if (!res.success) {
        return;
      }
      this.list = res.list;
      this.total = res.totalRows || 0;
      this.$emit("sendTotal", this.total);
    },
    //排序
    sortChange({ column, prop, order }) {
      if (order == "descending") {
        order = "desc";
        this.sort = { limit_time: order }
      } else if (order == "ascending") {
        order = "asc";
        this.sort = { limit_time: order }
      } else {
        this.sort = { create_time: "desc" }
      }
      if (prop == "limitTime") {
        this.getTaskPage(this.page, this.sort);
      }
    },
    //页面切换
    handleCurrentChange(newPage) {
      this.getTaskPage(newPage, this.sort);
      this.page = newPage
      // sessionStorage.setItem("myCurrentPage1", newPage);
    },
    toEditor(row) {
      let path = "/neweditor";
      let obj = Object();
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.taskName));
      sessionStorage.setItem("fileName", row.taskName)
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'project', 3);
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'transStatus', 1);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      Reflect.set(obj, 'companyCode', row.companyCode)
      //老版参数
      Reflect.set(obj, "fileId", row.fileId);
      Reflect.set(obj, "projectId", row.projectId);
      Reflect.set(obj, "isSplit", true);
      Reflect.set(obj, "type", "task");
      Reflect.set(obj, "taskType", row.taskType);
      Reflect.set(obj, "taskId", row.id);

      let routeData1 = this.$router.resolve({
        path,
        query: {
          key: this.$Base64.encode(JSON.stringify(obj))
        }
      });
      window.open(routeData1.href, "_self");
    },
    //下载
    handleTaskDownload(item) {
      let url = `/api/v1/file/outLineEditDownload?fileId=${item.fileId}&taskId=${item.id}`;
      this.taskDownload(url, {}, "get").then(function (resp) {
        if (resp.success) {
          let fileSuffix = resp.result.substring(resp.result.lastIndexOf(".") + 1);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = apiRoot(`/common/downloadFile?fileName=${item.projectName + '.' + fileSuffix}&filePath=${resp.result}`);
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    handleCancel: function (bool) {
      this.taskVisible = bool;
    },
    //上传
    handleTaskUpload(item) {
      this.taskInfo = {
        taskId: item.id,
        fileId: item.fileId
      };
      this.taskVisible = true;
    },
    //转换类型
    getTasktpyeName(row) {
      switch (row) {
        case 1:
          return this.$t("myTaskV2.translate");
        case 2:
          return this.$t("myTaskV2.checked");
        case 3:
          return this.$t("myTaskV2.school");
      }
    },
    //转换状态
    getTaskStateName(row) {
      switch (row) {
        case 0:
          return this.$t("myTaskV2.notStarted");
        case 1:
          return this.$t("myTaskV2.complete");
        case 2:
          return this.$t("myTaskV2.pedding");
      }
    }
  }
};
</script>
<style lang="less">
.filter-search {
  ul {
    width: 200px;

    li:last-child {
      display: flex;
      justify-content: center;

      .el-button+.el-button {
        margin-left: 20px;
      }
    }

    .fileter-title {
      color: #303133;
      font-size: 16px;
      line-height: 1; // margin-bottom: 12px;
      font-weight: bold;
    }

    .fileter-status {
      line-height: 12px;
      font-size: 14px;
    }

    li {
      color: #454545;
      text-align: left;

      .el-select {
        margin-top: 5px;
      }

      .el-input {
        height: 32px;

        // margin-top: 5px;
        .el-input__inner {
          height: 32px;
        }
      }

      .clearsearch {
        height: 32px;
        border: 1px solid #0078fc;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          display: block;
          width: auto;
          height: 16px;
          color: #0078fc;
          line-height: 16px;
        }
      }

      .search {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          display: block;
          width: auto;
          height: 16px;
          line-height: 16px;
        }
      }
    }

    li+li {
      margin-top: 12px;
    }
  }
}
.badge-index{
 .is-dot{
  height: 6px;
  width: 6px;
  position: absolute;
  top: -10px;
  right: -15px
 }
}
</style>
<style lang="less" scoped>
@import "./assets/style.less";
</style>